<template>
    <div class="message-person">
        <img :src="path" alt="">
    </div>
</template>
<script>
export default {
    props : {
        color : {
            type : String,
            required : true
        }
    },
    computed : {
        path(){
            let caminho = ''
            switch(this.color){
                case 'orange':
                    caminho = 'person-3'
                    break;
                case 'blue':
                    caminho = 'person-2'
                    break;
                case 'red':
                    caminho = 'person-1'
                    break;
            }
            return require(`../../assets/${caminho}.png`)
        }
    }
}
</script>
<style lang="scss" scoped>
    .message-person{
        width: 40%;
        height: 190px;
        position: absolute;
        bottom: 0;
        right: 20px;
        z-index: 20;
        display: flex;
        align-items: flex-end;

        img{
            width: 300px;
            height: 200px;
        }
    }

    @media only screen and (min-height: 700px){
        .message-person{

            img{
                height: 220px;
            }
        }
    }

    @media only screen and (min-width: 700px){
        .message-person{

            img{
                width: 180px;
                height: 230px;
            }
        }
    }
</style>
